import getApi from "../api/getApi";
import { regionConfigs } from "../config/regions";
import { nzBlogs } from "../data/nzBlogs";
import { usBlogs } from "../data/usBlogs";

export const getBlogSummaries = async (region = 'nz') => {
    // For NZ and US we use static data for SEO optimization
    if (region === 'nz') {
        return nzBlogs;
    }
    if (region === 'us') {
        return usBlogs;
    }

    const config = regionConfigs[region];
    const url = `${config.webUrl}DealerWebApp/GetPublishToWebsiteWebPageTextBlockSummaries?applicationId=${config.applicationId}`;

    try {
        const response = await getApi.get(url);
        return response.data || [];
    } catch (err) {
        throw err;
    }
};

export const getBlogDetail = async (slug, region) => {
    const blogs = region === 'nz' ? nzBlogs : region === 'us' ? usBlogs : [];
    const blog = blogs.find(b => b.WPTextBlockId === slug);
    return blog || null;
};

export const blogService = {
    getBlogSummaries,
    getBlogDetail
};
